import { Link } from "react-router-dom";
import { useGetAllAssignmentsQuery } from "../../../features/assignment/assignmentApi";
import Assignment from "./Assignment";

export default function Assignments() {
  const {
    data: assignments,
    isLoading,
    isError,
  } = useGetAllAssignmentsQuery() || {};
  // decide what to render
  let content = null;
  if (isLoading)
    content = (
      <tr>
        <td colSpan="4" style={{ textAlign: "center" }}>
          Loading....
        </td>
      </tr>
    );
  if (!isLoading && isError)
    content = (
      <tr>
        <td colSpan="4" style={{ textAlign: "center" }}>
          There was an error
        </td>
      </tr>
    );
  if (!isLoading && !isError && assignments?.length === 0)
    content = (
      <tr>
        <td colSpan="4" style={{ textAlign: "center" }}>
          No videos found
        </td>
      </tr>
    );
  if (!isLoading && !isError && assignments?.length > 0) {
    content = assignments.map((assignment, i) => (
      <Assignment key={i} assignment={assignment} />
    ));
  }
  return (
    <div className="px-3 py-20 bg-opacity-10">
      <Link to={"/admin/addassignment"}>
        <div className="w-full flex">
          <button className="btn ml-auto">Add Assignment</button>
        </div>
      </Link>
      <div className="overflow-x-auto mt-4">
        <table className="divide-y-1 text-base divide-gray-600 w-full">
          <thead>
            <tr>
              <th className="table-th">Title</th>
              <th className="table-th">Video Title</th>
              <th className="table-th">Mark</th>
              <th className="table-th">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-600/50">{content}</tbody>
        </table>
      </div>
    </div>
  );
}
